export default "__VITE_ASSET__b2d6390f__"